import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';


export interface RoleSearchRequest {
  code: string;
  descr: string;
}

@Component({
  selector: 'app-role-search',
  templateUrl: './role-search.component.html'
})
export class RoleSearchComponent implements OnInit {

  roleSearchForm: FormGroup;

  @Output() searchRole = new EventEmitter<RoleSearchRequest>();

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.buildForm();
  }

  private buildForm() {
    this.roleSearchForm = this.formBuilder.group({
      code: new FormControl(null),
      descr: new FormControl(null),
    });
  }

  get f() { return this.roleSearchForm.controls; }

  onSubmit() {
    if (this.roleSearchForm.invalid) {
        return;
    }

    this.searchRole.emit(this.roleSearchForm.value);
  }

  reset() {
    this.roleSearchForm.reset();
    this.searchRole.emit(this.roleSearchForm.value);
  }
}
